<template>
  <div class="flex w-full">
    <Splide
      class=""
      :has-track="false"
      :options="{ type: 'loop', autoplay: true, pagination: false, pauseOnHover: false }"
      aria-label="carouselBanner"
    >
      <SplideTrack class="rounded-lg">
        <!-- <SplideSlide v-for="(el, idx) in banners['0']" :key="idx"> -->
        <template v-for="data in content">
          <SplideSlide>
            <template v-if="hasAdvertisementLink(data)">
              <a
                v-if="isExternalAdvertisementLink(data)"
                class="relative flex"
                :href="getExternalLink(data?.link)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img class="w-full h-96 object-cover" :src="data?.image" alt="" />
                <div
                  style="background-color: rgba(96, 165, 250, 0.69)"
                  class="absolute w-full px-3 py-1 bottom-0 left-0 text-white z-10"
                >
                  {{ data?.title }}
                </div>
              </a>
              <router-link
                v-else
                class="relative flex"
                :to="{
                  name: getRouteParams(data).name,
                  params: getRouteParams(data).params,
                  query: getRouteParams(data).query,
                }"
              >
                <img class="w-full h-96 object-cover" :src="data?.image" alt="" />
                <div
                  style="background-color: rgba(96, 165, 250, 0.69)"
                  class="absolute w-full px-3 py-1 bottom-0 left-0 text-white z-10"
                >
                  <p class="">{{ data?.title }}</p>
                </div>
              </router-link>
            </template>
            <div v-else class="relative flex">
              <img class="w-full h-96 object-cover" :src="data?.image" alt="" />
              <div
                style="background-color: rgba(96, 165, 250, 0.69)"
                class="absolute w-full px-3 py-1 bottom-0 left-0 text-white z-10"
              >
                {{ data?.title }}
              </div>
            </div>
          </SplideSlide>
        </template>
      </SplideTrack>
    </Splide>
  </div>
</template>

<script>
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import {
  getRouteParams,
  getExternalLink,
  hasAdvertisementLink,
  isExternalAdvertisementLink,
} from '@/helpers';
export default {
  name: 'CarouselBanner',
  props: {
    content: {
      type: Array,
      default: [],
    },
  },
  components: {
    Splide,
    SplideSlide,
    SplideTrack,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    getRouteParams,
    getExternalLink,
    hasAdvertisementLink,
    isExternalAdvertisementLink,
  },
  computed: {},
  created() {},
};
</script>
